import React from 'react';
import { motion } from 'framer-motion';
import { WIZARD_STEPS } from './htsQuestionWizardConfig';
import styles from './HtsQuestionForm.module.scss';

interface WizardStepIndicatorProps {
  currentStep: number;
  maxReachedStep: number;
  onStepClick: (step: number) => void;
}

export const WizardStepIndicator: React.FC<WizardStepIndicatorProps> = ({
  currentStep,
  maxReachedStep,
  onStepClick,
}) => (
  <div className={styles.stepIndicator}>
    {WIZARD_STEPS.map((step, index) => {
      const filled = index <= currentStep;
      const isCurrent = index === currentStep;
      const isLocked = index > maxReachedStep;
      return (
        <div
          key={step.key}
          className={[styles.stepSegment, isLocked ? styles.stepSegmentLocked : ''].filter(Boolean).join(' ')}
          role="button"
          aria-disabled={isLocked}
          tabIndex={isLocked ? -1 : 0}
          onClick={() => !isLocked && onStepClick(index)}
          onKeyDown={(e) => {
            if (!isLocked && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              onStepClick(index);
            }
          }}
        >
          <div className={styles.stepBarTrack}>
            <motion.div
              className={styles.stepBarFill}
              initial={false}
              animate={{ opacity: filled ? 1 : 0 }}
              transition={{ duration: 0.25 }}
            />
          </div>
          <span className={[styles.stepLabel, isCurrent ? styles.stepLabelCurrent : ''].join(' ')}>
            {step.label}
          </span>
        </div>
      );
    })}
  </div>
);

export default WizardStepIndicator;
